import { Text } from '@fluentui/react-components';
import useSummaryCardStyles from './SummaryCard.styles';
import { useCart } from 'contexts/CartContext/CartContext.hooks';
import SummaryCardSection from './SummaryCard.section';
import HorizontalLine from '../../../components/core/HorizontalLine/HorizontalLine';
import { useEffect, useState } from 'react';
import { ICostSummaryItem } from '../../../contexts/CartContext/CartContext.types';
import { useLineEdit } from '../../../contexts/LineEditContext/LineEditContext.hooks';

const SummaryCard = () => {
    const styles = useSummaryCardStyles();

    const { cart } = useCart();

    const { GetMonthlyTotal, GetDueTodayTotal, GetAdditionalCostItems } = useLineEdit();

    const [monthlySummary, setMonthlySummary] = useState<ICostSummaryItem[]>();
    const [dueTodaySummary, setDueTodaySummary] = useState<ICostSummaryItem[]>();

    useEffect(() => {
        if (cart.monthlySummary) {
            const lineCostsMonthly: ICostSummaryItem[] = [];

            for (let x = 0; x < cart.lineItems.length; x++) {
                const dueForLine = GetMonthlyTotal(x + 1);
                // Some 'display' items might have a 0 amount but if they have children push them onto the
                // array so their children can be summed.
                if (
                    dueForLine.amount > 0 ||
                    (dueForLine.type == 'display' && (dueForLine.children?.length ?? 0) > 0)
                ) {
                    lineCostsMonthly.push(dueForLine);
                }
            }

            setMonthlySummary(lineCostsMonthly);
        }

        if (cart.dueTodaySummary) {
            const lineCostsToday: ICostSummaryItem[] = [];

            for (let x = 0; x < cart.lineItems.length; x++) {
                const dueForLine = GetDueTodayTotal(x + 1);
                // Some 'display' items might have a 0 amount but if they have children push them onto the
                // array so their children can be summed.
                if (
                    dueForLine.amount > 0 ||
                    (dueForLine.type == 'display' && (dueForLine.children?.length ?? 0) > 0)
                ) {
                    lineCostsToday.push(dueForLine);
                }
            }

            const additionalCosts = GetAdditionalCostItems();

            additionalCosts.forEach((a) => lineCostsToday.push(a));

            setDueTodaySummary(lineCostsToday);
        }
    }, [cart.monthlySummary, cart.dueTodaySummary, cart]);

    return (
        <div className={styles.root}>
            <div className={styles.contentWrapper}>
                <Text size={500} weight='semibold'>
                    Your Cart
                </Text>

                <HorizontalLine />
                <SummaryCardSection
                    title='Monthly Summary'
                    rows={monthlySummary ?? []}
                    totalText='Due Monthly'
                />

                <HorizontalLine />
                <SummaryCardSection
                    title="Today's Summary"
                    rows={dueTodaySummary ?? []}
                    totalText='Due Today'
                />

                {cart.fees.length > 0 && (
                    <>
                        <HorizontalLine />
                        <SummaryCardSection
                            title='Fee Summary'
                            rows={cart.fees}
                            totalText='Total Fees'
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default SummaryCard;
